export const DRAWER_HEIGHT_CSS_VAR = '--drawer-viewport-height';
export const MODAL_HEIGHT_CSS_VAR = '--modal-viewport-height';
